import React from 'react';
import ModulePlaceholder from '../common/ModulePlaceholder';

export default function Documents() {
  return (
    <ModulePlaceholder
      title="Documents"
      icon="📁"
      description="Store and organize supporting documents attached to invoices, bills, expenses and other records."
      related={[
        { label: 'Invoices', path: '/invoices' },
        { label: 'Bills', path: '/bills' },
        { label: 'Expenses', path: '/expenses' },
      ]}
    />
  );
}
